import forOwn from 'lodash/forOwn'
import saveSystemLog from "@/common/saveLog.js";
import quit from '@/common/quit.js'
import {
    Message
} from 'element-ui';
export const handleError = (error) => {
    let response = error.response
    if (response && (response.status == 401 || response.status == 403)) {
        quit()
    } else {
        if (response && error.response.data) {
            saveSystemLog("error", `错误信息：${error.response.data.message}；`)
            Message.error(error.response.data.message)
        } else {
            saveSystemLog("error", `错误信息：${error.toString()}；`)
            Message.error(error.toString())
        }
    }
}

import doctor from './componentsAPI/doctor'
import index from './componentsAPI/index'
import admin from './componentsAPI/admin'
import management from './componentsAPI/management'
import agent from './componentsAPI/agent'
import statistic from './componentsAPI/statistics'

const httpApi = {}
forOwn(admin, function (value, key) {
    httpApi[key] = value
});
forOwn(management, function (value, key) {
    httpApi[key] = value
});
forOwn(agent, function (value, key) {
    httpApi[key] = value
});
forOwn(doctor, function (value, key) {
    httpApi[key] = value
});
forOwn(index, function (value, key) {
    httpApi[key] = value
});
forOwn(statistic, function (value, key) {
    httpApi[key] = value
});

export default httpApi


// WEBPACK FOOTER //
// ./src/http/index.js